module.exports = __webpack_public_path__ + "img/018.52bb865f.jpg";